// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__18Ovz","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2VagG"};